<div>
  <div class="footer-container mt-5">
    <img
      *ngIf="witharc"
      [src]="arcPath"
      class="waves"
      alt="Wave to improve the UI/UX"
    />
    <img
      *ngIf="imageSrc"
      class="w-100 footer-img"
      [src]="imageSrc"
      alt="GenAI footer image for better UI/UX"
    />
  </div>

  <div class="mx-3 mx-md-5 my-3">
    <div class="d-block d-sm-flex justify-content-between align-items-center">
      <!-- <div class="d-flex gap-3 gap-sm-5 social-text">
        <div>
          <a
            [routerLink]="['/' + lang + '/services']"
            style="text-decoration: none; color: inherit; font-style: normal"
          >
            {{ "footer_service" | translate }}
          </a>
        </div>

        <div>
          <a
            [routerLink]="['/' + lang + '/contact']"
            style="text-decoration: none; color: inherit; font-style: normal"
          >
            {{ "footer_contectUs" | translate }}
          </a>
        </div>

        <div>
          <a
            [routerLink]="['/' + lang + '/policy']"
            style="text-decoration: none; color: inherit; font-style: normal"
          >
            {{ "footer_policy" | translate }}
          </a>
        </div>
        <div>
          <a
            [routerLink]="['/' + lang + '/refund-policy']"
            style="text-decoration: none; color: inherit; font-style: normal"
          >
            {{ "footer_refund_policy" | translate }}
          </a>
        </div>
      </div> -->

      <div class="d-flex mt-2 mt-sm-0 gap-4 social justify-content-start">
        <a
          *ngFor="let link of soicalMediaLinks"
          [href]="link.link || link.path"
          [attr.download]="link.name === 'portfolio' ? 'portfolio.pdf' : null"
          target="{{ link.name === 'portfolio' ? '_self' : '_blank' }}"
        >
          <fa-icon [icon]="icons[link.icon]"></fa-icon>
        </a>
      </div>
    </div>

    <hr />
    <div class="d-flex flex-column gap-3" *ngIf="locations">
      <div *ngFor="let loc of locations">
        <i class="bi bi-geo-alt-fill text-danger"></i>
        <span class="social-text mx-2">{{ loc | translate }}</span>
      </div>
    </div>
    <div class="d-flex flex-column gap-3 mt-2" *ngIf="emails">
      <div *ngFor="let email of emails">
        <i class="bi bi-envelope"></i>
        <span class="social-text mx-2">{{ email }} </span>
      </div>
    </div>
    <div class="d-flex justify-content-between align-items-center mt-2">
      <img width="120px" class="me-2" [src]="logoPath" alt="Company-logo" />

      <div class="social-text">{{ "footer_copyWrites" | translate }}</div>
    </div>
  </div>
</div>
